export const START_HEARTBEAT = 'START_HEARTBEAT';
export const STOP_HEARTBEAT = 'STOP_HEARTBEAT';